import type { ReviewActivityEvent } from './types'

/**
 * The review-activity endpoint returns newest first. Sort a copy so the request detail
 * viewer stays newest-first even if a page arrives out of order.
 */
export const sortReviewActivityEventsNewestFirst = (events: ReviewActivityEvent[]): ReviewActivityEvent[] =>
  [...events].sort((left, right) => Date.parse(right.occurredAt) - Date.parse(left.occurredAt))
